<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>
                    <span v-if="editMode">Urejanje uporabnika</span>
                    <span v-if="!editMode">Dodajanje uporabnika</span>
                </h1>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <!--                {{user}}-->
                <!--                <br/><br/>-->
                <!--                {{roles}}-->


                <b-form-group
                        id="name"
                        label="Vnesi ime"
                        label-for="name">
                    <b-form-input id="name" v-model="user.first_name" trim></b-form-input>
                </b-form-group>

                <b-form-group
                        id="lastName"
                        label="Vnesi priimek"
                        label-for="lastName">
                    <b-form-input id="lastName" v-model="user.last_name" trim></b-form-input>
                </b-form-group>

                <b-form-group
                        id="email"
                        label="Vnesi e-poštni naslov"
                        label-for="email">
                    <b-form-input id="email" v-model="user.email" type="email" trim></b-form-input>
                </b-form-group>

                <b-form-group
                        id="photo"
                        label="Vnesi url naslov slike"
                        label-for="photo">
                    <b-form-input id="photo" v-model="user.photo" trim></b-form-input>
                </b-form-group>

                <b-form-group
                        label="Določi vlogo"
                        label-for="role">

                    <v-select
                            v-model="user.role"
                            id="role"
                            name="role"
                            :options="roles"
                            label="name"
                            :reduce="item => item.id"
                    />
                </b-form-group>


                <b-form-group label="Ali je uporabnik v Zavodu Dobra pot zaposlen?">
                    <div>
                        <b-form-checkbox
                                v-model="user.isEmployed"
                                size="lg"
                                switch> Uporabnik je zaploslen v Zavodu Dobra pot</b-form-checkbox>
                    </div>
                </b-form-group>

                <b-form-group label="Ali je uporabnik aktiven?">
                    <div>
                        <b-form-checkbox
                                v-model="user.active"
                                size="lg"
                                switch> Uporabnik aktiven</b-form-checkbox>
                    </div>
                </b-form-group>

                <b-form-group label="Ali je uporabnik administrator sistema?">
                    <div>
                        <b-form-checkbox
                                v-model="user.administrator"
                                size="lg"
                                switch> Uporabnik ima administratorske pravice</b-form-checkbox>
                    </div>
                </b-form-group>


            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mt-3">
                <div class="d-flex">
                    <button v-if="editMode" class="btn btn-danger mr-auto" @click="deleteUserConfirmation()"><i class="fa fa-trash"></i>
                        Izbriši
                        uporabnika
                    </button>

                    <button v-if="!editMode" type="submit" @click="addUser()" class="btn btn-info ml-auto"><i
                            class="fa fa-save"></i> Shrani podatke o uporabniku
                    </button>


                    <button v-if="editMode" type="submit" @click="updateUser()" class="btn btn-info ml-auto"><i
                            class="fa fa-save"></i> Posodobi podatke o uporabniku
                    </button>
                </div>

                <div>

                    <router-link :to="{ name: 'Users'}" class="btn btn-link pt-4">
                        Prekliči
                    </router-link>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import firebase from 'firebase'
  import {db} from '../main'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'

  export default {
    name: 'EditUser',
    components: {
      vSelect
    },
    data () {
      return {
        user: {
          id: null,
          first_name: '',
          last_name: '',
          email: '',
          photo: '',
          active: false,
          deleted: false,
          updatedAt: null,
          updatedBy: '',
          createdAt: null,
          createdBy: null,
          administrator: false,
          isEmployed: false
        },
        roles: [],
        id: this.$route.params.id,
        editMode: false,
        currentUser: null
      }
    },
    firestore () {
      if (this.id) {
        return {
          user: db.collection('users').doc(this.id),
          roles: db.collection('roles')
        }
      } else {
        return {
          roles: db.collection('roles')
        }
      }
    },
    mounted () {

      if (this.id) {
        this.editMode = true
      } else {
        this.editMode = false
      }

    },
    methods: {

      updateUser (id) {
        const _this = this
        const currentUser = db.collection('users').doc(this.id)

        return currentUser.update({
          first_name: _this.user.first_name,
          last_name: _this.user.last_name,
          email: _this.user.email,
          photo: _this.user.photo,
          role: _this.user.role,
          active: _this.user.active,
          updatedAt: new Date(),
          updatedBy: JSON.parse(sessionStorage.getItem('DP_user')).id,
          createdAt: _this.user.createdAt,
          createdBy: _this.user.createdBy,
          administrator: _this.user.administrator,
          isEmployed: _this.user.isEmployed
        })
          .then(function () {
            _this.$store.dispatch('retrieveUsers', true).then(() => {
              _this.$router.push('/uporabniki')
            })
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error updating user: ', error)
          })

      },

      addUser () {
        const _this = this

        let ref = db.collection('users').doc()
        ref.set({id: ref.id}) // set new document ID
          .then(() => {  // fetch the doc again and show its data
            ref.get().then(doc => {

              _this.id = doc.data().id
              _this.user.createdAt = new Date()
              _this.user.createdBy = JSON.parse(sessionStorage.getItem('DP_user')).id
              _this.updateUser()
            })
          })

      },
      deleteUserConfirmation () {
        const _this = this

        this.$swal({
          title: 'Opozorilo',
          text: 'Ali ste prepričani, da želite izbrisati uporabnika ' + _this.user.first_name + ' ' + _this.user.last_name + '? Po potrditvi izbire ne bo več mogoče preklicati.',
          dangerMode: true,
          buttons: {
            cancel: {
              text: 'Prekliči',
              value: null,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Izbriši',
              value: true,
              visible: true,
              className: '',
              closeModal: true
            }
          },
        })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteUser()

              case null:

                return

                break

              default:

            }
          })
      },
      deleteUser () {
        const _this = this

        db.collection('users').doc(_this.id).delete()
          .then(function () {
            _this.$router.push('/uporabniki')
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting user: ', error)
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/EditUser.vue